import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import Spinner from './_spinner.js'
import TextInput from './_text-input.js'
import Button from './_button.js'
import ConfigurableMargin from './_configurable-margin.js'

export default {
  name: 'SearchInput',
  values: {
    container: {
      base: {
        configSet: FlexPane,
        configValues: {
          style: {
            boxSizing: 'border-box',
            alignItems: 'center',
            minWidth: '40px',
            minHeight: '40px',
            maxHeight: '40px',
          },
        },
      },
      active: {
        configSet: FlexPane,
        configValues: {},
      },
      inactive: {
        configSet: FlexPane,
        configValues: {},
      },
    },
    searchIconContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
        },
      },
    },
    inactiveSearchIcon: {
      configSet: Image,
      configValues: {
        src: 'system-search',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    activeSearchIcon: {
      configSet: Image,
      configValues: {
        src: 'system-search',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    spinnerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          minWidth: '32px',
          minHeight: '32px',
        },
      },
    },
    spinner: {
      configSet: Spinner,
      configValues: {},
    },
    inputContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexBasis: '100%',
          alignItems: 'center',
          zIndex: '1000',
        },
      },
    },
    inputParams: {
      autoCorrect: 'off',
    },
    textInput: {
      configSet: TextInput,
      configValues: {
        class: 'SearchInput',
        style: {
          base: {
            borderWidth: '0px',
            outline: 'none',
          },
        },
      },
    },
    clearButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            alignItems: 'center',
            minWidth: '40px',
            minHeight: '40px',
          },
        },
      },
    },
    clearIcon: {
      configSet: Image,
      configValues: {
        src: 'system-clear-outline',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    style: {
      wrapperContainer: {
        margin: '4px',
        $mixin: [
          {
            configSet: ConfigurableMargin,
          },
        ],
      },
    },
  },
  meta: {
    extendable: false,
  },
}
